import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface TaxRateDetail {
  id: number;
  name: string;
  tax: number;
  status: "BLOCKED" | "ACTIVE" | "PASSIVE";
  merchantId: number;
  createDate?: string;
  createUserId?: number;
  updateDate?: string;
  updateUserId?: number;
  systemDate?: string;
  deleteDate?: string;
  deleteUserId?: number;
}

export type GetTaxRateDetailResponse = BaseResponse<TaxRateDetail>;

async function getTaxRateDetail(id: number): Promise<GetTaxRateDetailResponse> {
  try {
    return (await axiosInstance.get(`/Product/GetTaxRate?id=${id}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetTaxRateDetail() {
  return useMutation<GetTaxRateDetailResponse, Error, number>(
    (id) => getTaxRateDetail(id)
  );
}